import { Link } from "react-router-dom";
import { Terminal } from "lucide-react";

export default function Navbar() {
  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 border-b"
      style={{
        background: "rgba(10, 10, 10, 0.8)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        borderColor: "rgba(255,255,255,0.08)",
      }}
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 no-underline" data-testid="logo-link">
          <Terminal className="w-5 h-5 text-white" strokeWidth={2.5} />
          <span
            className="text-xl font-bold tracking-tighter text-white"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            runzr
          </span>
        </Link>

        <div className="flex items-center gap-6">
          <Link
            to="/demo"
            data-testid="nav-demo-link"
            className="text-sm no-underline transition-colors duration-200"
            style={{ color: "#A1A1AA" }}
            onMouseEnter={(e) => (e.target.style.color = "#fff")}
            onMouseLeave={(e) => (e.target.style.color = "#A1A1AA")}
          >
            Demo
          </Link>
          <a
            href="#features"
            className="text-sm no-underline transition-colors duration-200 hidden sm:inline"
            style={{ color: "#A1A1AA" }}
            onMouseEnter={(e) => (e.target.style.color = "#fff")}
            onMouseLeave={(e) => (e.target.style.color = "#A1A1AA")}
          >
            Features
          </a>
          <a
            href="#security"
            className="text-sm no-underline transition-colors duration-200 hidden sm:inline"
            style={{ color: "#A1A1AA" }}
            onMouseEnter={(e) => (e.target.style.color = "#fff")}
            onMouseLeave={(e) => (e.target.style.color = "#A1A1AA")}
          >
            Security
          </a>
          <a
            href="#waitlist"
            data-testid="nav-waitlist-link"
            className="text-sm px-4 py-2 rounded-full no-underline transition-all duration-200 font-medium"
            style={{
              background: "#fff",
              color: "#000",
            }}
            onMouseEnter={(e) => (e.target.style.opacity = "0.9")}
            onMouseLeave={(e) => (e.target.style.opacity = "1")}
          >
            Request Access
          </a>
        </div>
      </div>
    </nav>
  );
}
